export default "__VITE_ASSET__JYcos6b9__"